'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.monthsAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/monthsAgo.js
// module id = 199
// module chunks = 0